import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
	XThemeForm,
	XSwitch,
	XThemeContainer,
	XThemeDetailsCards,
	XThemeInputText,
	XThemeRadio,
	XThemeSwitchBtn,
	XThemeButton,
	XThemeTable,
	XThemeTag,
	XTag,
} from '../../../../../styles/GlobalThemeStyle';
import {
	Row,
	Col,
	Button,
	Input,
	notification,
	Flex,
	Space,
	Table,
	Form,
} from 'antd';
import {
	XThemeTilesCard,
	XThemeVoiceAssCard,
	XThemeVoiceaAsistCard,
	XThemeVoiceAssSeeBtn,
	XThemeVoiceAssTable,
	XThemeVoiceAssTableCard,
	XThemeVoiceAssTitle,
	XThemeVoiceCreateCaseBtn,
	XThemeVoiceaAsistChartCard,
	XThemeVoiceaAssSearchBar,
	XThemeFitToScreen,
	XThemeFixBottom,
	XThemeVoiceaAsistChatCard,
	XThemeVSSetViewPort,
	XThemeVSScrollContainer,
	XVSLottie,
	XVSLottieCaseCentralization,
	XVSLovable,
} from '../../../VoiceAssistanceStyle';
import { PlusCircleOutlined } from '@ant-design/icons';
import CaseCentralization from '../../../../../json/case_centralization.json';

const VATimelineLoader = (props) => {
	const columns = [
		{
			title: '##',
			dataIndex: 'serialNo',
		},
		{
			title: 'Stg.',
			dataIndex: 'stg',
		},
		{
			title: 'Case ID',
			dataIndex: 'caseID',
		},
		{
			title: 'Patient ID',
			dataIndex: 'patientID',
		},
		{
			title: 'Case Name',
			dataIndex: 'caseName',
		},
		{
			title: 'Insurance Company',
			dataIndex: 'insuranceCompany',
			width: '25%',
		},
		{
			title: 'Status',
			dataIndex: 'status',
			align: 'center',
		},
	];

	const dataSource = Array.from({
		length: 10,
	}).map((_, i) => ({
		key: i,
		serialNo: <div className="tablecount">{i + 1}</div>,
		stg: (
			<div className="tablecountStd">
				{i + 1}
				<sup>nd</sup>
			</div>
		),
		caseID: 'MASB02001',
		patientID: 'MGB02',
		caseName: 'Mouse MTST',
		insuranceCompany: 'Novitas Solutions, Inc.',
		status: (
			<XThemeTag style={{ background: '#ED982A33', color: '#ED982A' }}>
				Pending
			</XThemeTag>
		),
	}));

	// List items for scrolling
	const listItems = [
		'Scanning all incoming cases — hang tight, almost there!',
		'Scanning all incoming cases — hang tight, almost there!',
		'Checking for missing details and patterns you should know.',
	];

	// Create a duplicated list for seamless scrolling
	// We need 7 items to ensure the first item is always visible during scrolling
	const duplicatedItems = [
		...listItems,
		...listItems,
		...listItems.slice(0, 1),
	];

	// Add a useEffect to ensure the animation works properly
	useEffect(() => {
		// Force a re-render to ensure the animation starts
		const scrollContent = document.querySelector('.scroll-content');
		if (scrollContent) {
			scrollContent.style.animation = 'none';
			setTimeout(() => {
				scrollContent.style.animation = 'scroll 10s linear infinite';
			}, 10);
		}
	}, []);

	return (
		<>
			<XThemeVSSetViewPort className="displyBlock">
				<XThemeVSScrollContainer>
					<Row gutter={[15, 15]}>
						<Col xs={24}>
							<XVSLottieCaseCentralization
								className="relativePositions"
								animationData={CaseCentralization}
								loop={true}
							/>
						</Col>
						<Col xs={24}>
							<XVSLovable>
								<div className="scroll-container">
									<div className="scroll-content">
										<ul>
											{duplicatedItems.map(
												(item, index) => (
													<li key={index}>{item}</li>
												),
											)}
										</ul>
									</div>
								</div>
							</XVSLovable>
						</Col>
					</Row>
				</XThemeVSScrollContainer>
			</XThemeVSSetViewPort>
		</>
	);
};

export default VATimelineLoader;
